import Controller, { OnClick, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';

import BaseController from '../../../BaseController';
import { HealthHistoryMedicinesListAliases as Alias, FragmentNames } from '../../../../codegen';
import { ApplicationRoute } from '../../../../constants/routes';
import { PanelAPI } from '@philips-internal/oswald-ui-components';
import { HealthHistoryListContext } from '../../service/health-history-list-service';
import { Inject } from '@odinjs/odin';
import InformationBarUtils from '../../../../controllers/commons/header/information-bar-header-utils';

@Controller ({ component: Alias.LAYOUT_HEALTH_HISTORY_MEDICINES_LIST, fragment: FragmentNames.HEALTH_HISTORY_MEDICINES_LIST })
export default class HealthHistoryAllergiesListController extends BaseController {

  @Inject(Alias.PANEL_HEALTH_HISTORY_MEDICINES)
  private panelHealthHistoryMedicinesAPI!: PanelAPI;

  @OnMount(Alias.LAYOUT_HEALTH_HISTORY_MEDICINES_LIST)
  handleMountLayoutAllergiesList(): void {
    const allowInfo = InformationBarUtils.allowInfo && HealthHistoryListContext.isAllowEdit;
    this.panelHealthHistoryMedicinesAPI.setVisible(allowInfo);
  }

  @OnClick({ target: Alias.DECK_HEALTH_HISTORY_MEDICINES })
  handleClickCard(event: ClickEvent): void {
    const { idHealthHistory, releaseDate } = event.value;
    const { encounterId, patientId } = this.historyService.getCurrentRouteParams();
    const allowInfo = InformationBarUtils.allowInfo && HealthHistoryListContext.isAllowEdit;
    const accessViewer = releaseDate || !allowInfo;
    const route = accessViewer ? ApplicationRoute.HEALTH_HISTORY_MEDICINE_VIEWER : ApplicationRoute.HEALTH_HISTORY_MEDICINES_EDIT;

    applicationContext.redirect(route, {
      encounterId,
      idHealthHistory,
      patientId
    })
  }

  @OnClick({ target: Alias.BUTTON_ADD_HEALTH_HISTORY_MEDICINES })
  handleClickButton(): void {
    const { encounterId, patientId } = this.historyService.getCurrentRouteParams();
    applicationContext.redirect(
      ApplicationRoute.HEALTH_HISTORY_MEDICINES_CREATE, {
        encounterId,
        patientId,
      }
    )
  }
}
